import { SKYSCANNER_VIEW_ID } from '@web-platform/shared-universal-constants/src/adsRetrievalServiceHeaders';

export type AdsRetrievalHeaderVariables = {
  viewId?: string | null;
  channel?: string; // optional; future Acorn consumer can pass its own channel id
};

export function defaultHeaders(variables: AdsRetrievalHeaderVariables): Record<string, string> {
  const headers: Record<string, string> = {};
  const { viewId } = variables;

  if (viewId) {
    headers[SKYSCANNER_VIEW_ID] = viewId;
  }

  return headers;
}
